/**
 * @file 在组件渲染时修改document.title
 * @author zhanglili
 */

import {lifecycle, wrapDisplayName} from 'recompose';
import {constant, identity} from 'lodash';

const setTitle = title => Component => {
    const getTitle = typeof title === 'function' ? title : constant(title);
    const hooks = {
        componentDidMount() {
            document.title = getTitle(this.props);
        },
        componentDidUpdate() {
            document.title = getTitle(this.props);
        }
    };

    const WrappedComponent = lifecycle(hooks)(Component);
    WrappedComponent.displayName = wrapDisplayName(Component, 'setTitle');

    return WrappedComponent;
};

export default (typeof document === 'undefined' ? constant(identity) : setTitle);
